// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2I4Zk","tab":"Tabs_tab__2iVq7","tabActive":"Tabs_tabActive__18RCE"};